// pages/CheckinCheckoutMovil.js - Versión corregida con botón DNI siempre visible

import React, { useState, useEffect, useRef } from 'react';
import {
  NavBar,
  SearchBar,
  DatePicker,
  Tabs,
  Card,
  Button,
  Space,
  Toast,
  Modal,
  Form,
  Input,
  List,
  Avatar,
  Tag,
  Badge,
  FloatingBubble,
  Popup,
  PullToRefresh,
  InfiniteScroll,
  Skeleton
} from 'antd-mobile';
import {
  SearchOutline,
  CalendarOutline,
  UserOutline,
  HomeOutline,
  ScanOutline,
  CheckOutline,
  CloseOutline,
  AddOutline,
  ArrowLeftOutline,
  TeamOutline,
  IdcardOutline
} from 'antd-mobile-icons';

import {
  ExclamationCircleOutlined, FilterOutlined, IdcardOutlined,
  DeleteOutlined, LoadingOutlined,
  SearchOutlined,
  CalendarOutlined,
  UserOutlined,
  HomeOutlined,
  KeyOutlined
} from '@ant-design/icons';

import dayjs from 'dayjs';
import axios from 'axios';
import { BASE_URL } from '../utils/constants';
import LectorDNIMobile from '../components/LectorDNIMobile';
import AsignarHabitacionMovil from '../components/AsignarHabitacionMovil';
import ModalOcupantesMovil from '../components/ModalOcupantesMovil';

const CheckinCheckoutMovil = () => {
  // Estados
  const [activeTab, setActiveTab] = useState('entradas');
  const [habitaciones, setHabitaciones] = useState([]);
  const [filteredHabitaciones, setFilteredHabitaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());
  const [searchText, setSearchText] = useState('');
  const [searchHabitacion, setSearchHabitacion] = useState('');
  
  // Estados para modales
  const [lectorVisible, setLectorVisible] = useState(false);
  const [asignarVisible, setAsignarVisible] = useState(false);
  const [lineaSeleccionada, setLineaSeleccionada] = useState(null);
  const [reservaSeleccionada, setReservaSeleccionada] = useState(null);
  const [ocupantesModalVisible, setOcupantesModalVisible] = useState(false);
  const [ocupantesList, setOcupantesList] = useState([]);

  const [ocupantesData, setOcupantesData] = useState({
    numReserva: null,
    linea: null,
    nombre: '',
    numHabitacion: null
  });  

  const [contadores, setContadores] = useState({
    entradasPendientes: 0,
    entradasTotal: 0,
    salidasPendientes: 0,
    salidasTotal: 0
  });  

  // Cargar datos
  useEffect(() => {
    cargarDatos();
  }, [fechaSeleccionada, activeTab]);

  // Filtrar habitaciones
  useEffect(() => {
    let filtered = [...habitaciones];
    
    if (searchText) {
      filtered = filtered.filter(h => 
        h.clientes?.some(c => 
          c.nombre?.toLowerCase().includes(searchText.toLowerCase()) ||
          c.numreserva?.toString().includes(searchText)
        )
      );
    }
    
    if (searchHabitacion) {
      filtered = filtered.filter(h => 
        h.NumHab?.toString().includes(searchHabitacion)
      );
    }
    
    setFilteredHabitaciones(filtered);    
    
  }, [searchText, searchHabitacion, habitaciones]);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const fechaFormateada = dayjs(fechaSeleccionada).format('YYYY-MM-DD');
      
      const endpoint = activeTab === 'entradas' ? 'entradas' : 'salidas';
      const response = await axios.get(
        `${BASE_URL}/api/checkin-checkout/${endpoint}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { fecha: fechaFormateada }
        }
      );
      
      const habitacionesMap = new Map();
      
      response.data.data.forEach(linea => {
        const numhab = linea.numhab2 || 'sin-asignar';
        
        if (!habitacionesMap.has(numhab)) {
          habitacionesMap.set(numhab, {
            numhab: numhab,
            clientes: [],
            estado: linea.entro ? 'checkin' : 'pendiente',
            tipoHab: linea.tipohab,
            regimen: linea.regimen
          });
        }
        
        habitacionesMap.get(numhab).clientes.push({
          numreserva: linea.numreserva,
          linea: linea.linea,
          nombre: linea.nombre,
          numocupante: linea.numocupante || 1,
          entro: linea.entro,
          salio: linea.salio,
          dni: linea.dni,
          snumero: linea.snumero,
          entrada: linea.entrada,
          salida: linea.salida,
          numHabitacion: linea.numhab,
          tipohab: linea.tipohab
        });
      });
      
      const habitacionesArray = Array.from(habitacionesMap.values());
      setHabitaciones(habitacionesArray);
      setFilteredHabitaciones(habitacionesArray);                      
      
    } catch (error) {
      console.error('Error cargando datos:', error);
      Toast.show({
        content: 'Error al cargar los datos',
        icon: 'fail'
      });
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    if (habitaciones.length > 0) {
      let entradasPendientes = 0;
      let entradasTotal = 0;
      let salidasPendientes = 0;
      let salidasTotal = 0;
      
      habitaciones.forEach(habitacion => {
        habitacion.clientes.forEach(cliente => {
          // Solo contar líneas CON habitación asignada
          if (habitacion.numhab !== 'sin-asignar') {
            if (activeTab === 'entradas' || true) {
              if (!cliente.entro) {
                entradasPendientes++;
              }
              entradasTotal++;
            }
            
            if (!cliente.salio) {
              salidasPendientes++;
            }
            salidasTotal++;
          }
        });
      });
      
      setContadores({
        entradasPendientes,
        entradasTotal,
        salidasPendientes,
        salidasTotal
      });
    }
  }, [habitaciones, activeTab]);

  const abrirModalOcupantes = (cliente) => {        
    setOcupantesData({
      numReserva: cliente.numreserva,
      linea: cliente.linea,
      nombre: cliente.nombre,
      numHabitacion: cliente.numHabitacion
    });
    setOcupantesModalVisible(true);
  };

  const onRefresh = async () => {
    setRefreshing(true);
    await cargarDatos();
  };

  const abrirLectorDNI = (cliente, habitacion) => {
    setLineaSeleccionada(cliente);
    setReservaSeleccionada({
      numReserva: cliente.numreserva,
      linea: cliente.linea,
      numOcupante: cliente.numocupante,
      nombre: cliente.nombre
    });
    setLectorVisible(true);
  };

  // Abrir asignación de habitación DIRECTAMENTE (sin modal de confirmación)
  const abrirAsignarHabitacion = (cliente, habitacion) => {
    setLineaSeleccionada(cliente);
    setAsignarVisible(true);
  };

  const handleCheckin = async (cliente, habitacion) => {
    // Verificar si tiene habitación asignada
    if (habitacion.numhab === 'sin-asignar') {
      Toast.show({
        content: '⚠️ No puedes hacer checkin sin habitación asignada. Primero asigna una habitación.',
        icon: 'fail',
        duration: 3000
      });
      return;
    }
    
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${BASE_URL}/api/checkin-checkout/checkin`,
        {
          numReserva: cliente.numreserva,
          linea: cliente.linea,
          aplicarATodaHabitacion: true,
          valor: cliente.entro ? 0 : 1
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      Toast.show({
        content: cliente.entro ? 'Checkin cancelado' : 'Checkin realizado',
        icon: 'success'
      });
      
      await cargarDatos();
    } catch (error) {
      Toast.show({
        content: 'Error al procesar',
        icon: 'fail'
      });
    }
  };

  const handleCheckout = async (cliente) => {
    Modal.confirm({
      title: 'Confirmar Checkout',
      content: `¿Realizar checkout para ${cliente.nombre}?`,
      onConfirm: async () => {
        try {
          const token = localStorage.getItem('token');
          await axios.post(
            `${BASE_URL}/api/checkin-checkout/checkout`,
            {
              numReserva: cliente.numreserva,
              linea: cliente.linea,
              aplicarATodaHabitacion: true
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          
          Toast.show({
            content: 'Checkout realizado',
            icon: 'success'
          });
          
          await cargarDatos();
        } catch (error) {
          Toast.show({
            content: 'Error al procesar',
            icon: 'fail'
          });
        }
      }
    });
  };

  const handleDNIProcesado = async (data) => {
    Toast.show({
      content: `DNI leído: ${data.numero_documento}`,
      icon: 'success',
      duration: 2000
    });
    setLectorVisible(false);
    await cargarDatos();
  };

  // Renderizar tarjeta de habitación
  const renderHabitacionCard = (habitacion, index) => {    
    const isSinAsignar = habitacion.numhab === 'sin-asignar';
    const todosCheckin = habitacion.clientes.every(c => c.entro);
    const todosCheckout = habitacion.clientes.every(c => c.salio);
    const algunCheckin = habitacion.clientes.some(c => c.entro);
    const algunCheckout = habitacion.clientes.some(c => c.salio);    
    
    return (
      <Card
        key={index}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <HomeOutlined fontSize={20} />
            <span style={{ fontWeight: 'bold' }}>
              {isSinAsignar ? '🚫 Sin habitación asignada' : `🏠 Habitación ${habitacion.numhab}`}
            </span>
            {!isSinAsignar && activeTab === 'entradas' && (
              <Tag color={todosCheckin ? 'success' : algunCheckin ? 'warning' : 'default'} size='small'>
                {todosCheckin ? '✓ Completado' : algunCheckin ? '⚠ Parcial' : '⏳ Pendiente'}
              </Tag>
            )}
            {!isSinAsignar && activeTab === 'salidas' && (
              <Tag color={todosCheckout ? 'success' : algunCheckout ? 'warning' : 'default'} size='small'>
                {todosCheckout ? '✓ Completado' : algunCheckout ? '⚠ Parcial' : '⏳ Pendiente'}
              </Tag>
            )}
          </div>
        }
        style={{ marginBottom: 12 }}
        bodyStyle={{ padding: '0 12px 12px 12px' }}
      >
        {/* Información de la habitación */}
        {!isSinAsignar && (
          <div style={{ 
            display: 'flex', 
            gap: 8, 
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: '1px solid #e5e5e5',
            fontSize: 12,
            color: '#666'
          }}>
            <span>Tipo: {habitacion.tipoHab || 'N/A'}</span>
            <span>•</span>
            <span>Régimen: {habitacion.regimen || 'N/A'}</span>
          </div>
        )}
        
        {/* Lista de clientes */}
        <List mode='card' style={{ '--padding-left': '0px' }}>
          {habitacion.clientes.map((cliente, idx) => (
            <List.Item
              key={idx}
              prefix={
                <Avatar
                  style={{ backgroundColor: cliente.entro ? '#52c41a' : '#faad14' }}
                >
                  {cliente.numocupante}
                </Avatar>
              }
              description={
                <div style={{ fontSize: 12 }}>
                  <div>Reserva: #{cliente.numreserva} - Línea: {cliente.linea}</div>
                  {cliente.dni && <div style={{ color: '#52c41a' }}>✓ DNI: {cliente.dni}</div>}
                  {!cliente.dni && activeTab === 'entradas' && (
                    <div style={{ color: '#ff4d4f' }}>⚠ DNI pendiente</div>
                  )}
                  {isSinAsignar && (
                    <div style={{ color: '#ff4d4f' }}>⚠ Sin habitación asignada</div>
                  )}
                </div>
              }
              extra={
                <Space direction='vertical' style={{ gap: 4 }}>
                  {/* Botón Asignar Habitación - Solo para líneas sin habitación */}
                  {isSinAsignar && (
                    <Button
                      size='small'
                      color='primary'
                      onClick={() => abrirAsignarHabitacion(cliente, habitacion)}
                      style={{ fontSize: 12 }}
                    >
                      <KeyOutlined /> Asignar
                    </Button>
                  )}
                  
                 
                  {activeTab === 'entradas' && !isSinAsignar && (
                    <Button
                      size='small'
                      color={cliente.entro ? 'default' : 'primary'}
                      onClick={() => handleCheckin(cliente, habitacion)}
                      style={{ fontSize: 12 }}
                    >
                      {cliente.entro ? 'Cancelar' : 'Checkin'}
                    </Button>
                  )}
                  
                  {activeTab === 'salidas' && !isSinAsignar && (
                    <Button
                      size='small'
                      color={cliente.salio ? 'default' : 'danger'}
                      onClick={() => handleCheckout(cliente)}
                      style={{ fontSize: 12 }}
                    >
                      {cliente.salio ? '✓ Hecho' : 'Checkout'}
                    </Button>
                  )}
                  
                  {/* Botón Ocupantes - Para ver detalles completos */}
                  <Button
                    size='small'
                    fill='none'
                    onClick={() => abrirModalOcupantes(cliente)}
                    style={{ fontSize: 12 }}
                  >
                    <TeamOutline /> Ocup.
                  </Button>
                </Space>
              }
            >
              <div style={{ fontWeight: 'bold' }}>{cliente.nombre}</div>
              <div style={{ fontSize: 11, color: '#666' }}>
                Tipo: {cliente.tipohab || habitacion.tipoHab || 'N/A'}
              </div>
            </List.Item>
          ))}
        </List>
        
        {/* Botón de asignación masiva para toda la tarjeta sin habitación */}
        {isSinAsignar && (
          <div style={{ 
            marginTop: 12, 
            paddingTop: 12, 
            borderTop: '1px solid #e5e5e5',
            textAlign: 'center'
          }}>
            <Button
              block
              color='primary'
              size='middle'
              onClick={() => {
                const primerCliente = habitacion.clientes[0];
                abrirAsignarHabitacion(primerCliente, habitacion);
              }}
              style={{ fontSize: 14 }}
            >
              <KeyOutlined /> Asignar habitación a este grupo
            </Button>
            <div style={{ fontSize: 11, color: '#999', marginTop: 8 }}>
              {habitacion.clientes.length} {habitacion.clientes.length === 1 ? 'persona' : 'personas'} sin habitación asignada
            </div>
          </div>
        )}
      </Card>
    );
  };

  return (
    <>
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        flexDirection: 'column',
        backgroundColor: '#f5f5f5'
      }}>
        {/* Header */}
        <NavBar
          back={null}
          style={{
            background: 'white',
            borderBottom: '1px solid #e5e5e5',
            position: 'sticky',
            top: 0,
            zIndex: 100
          }}
          right={
            <Button
              size='small'
              fill='none'
              onClick={cargarDatos}
              loading={loading}
            >
              🔄
            </Button>
          }
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>Checkin/Out</span>
            <Tag color='processing'>{dayjs(fechaSeleccionada).format('DD/MM/YYYY')}</Tag>
          </div>
        </NavBar>

        {/* Selector de fecha */}
        <div style={{ 
          padding: 12, 
          background: 'white', 
          borderBottom: '1px solid #e5e5e5',
          display: 'flex',
          gap: 8,
          alignItems: 'center'
        }}>
          <Button
            size='small'
            onClick={() => setFechaSeleccionada(dayjs(fechaSeleccionada).subtract(1, 'day').toDate())}
          >
            ◀
          </Button>
          <DatePicker
            value={fechaSeleccionada}
            onChange={setFechaSeleccionada}
            precision='day'
            renderLabel={(value) => dayjs(value).format('DD/MM/YYYY')}
          />
          <Button
            size='small'
            onClick={() => setFechaSeleccionada(new Date())}
          >
            Hoy
          </Button>
          <Button
            size='small'
            onClick={() => setFechaSeleccionada(dayjs(fechaSeleccionada).add(1, 'day').toDate())}
          >
            ▶
          </Button>
        </div>

        {/* Buscadores */}
        <div style={{ padding: 12, background: 'white', gap: 8, display: 'flex', flexDirection: 'column' }}>
          <SearchBar
            placeholder='Buscar por nombre o reserva'
            value={searchText}
            onChange={setSearchText}
            clearable
          />
          <SearchBar
            placeholder='Buscar por habitación'
            value={searchHabitacion}
            onChange={setSearchHabitacion}
            clearable
            style={{ '--background': '#f5f5f5' }}
          />
        </div>

        {/* Tabs */}
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          style={{ background: 'white' }}
        >
          <Tabs.Tab 
            title={
              <span>
                📅 Entradas 
                {contadores.entradasPendientes > 0 && (
                  <span style={{ 
                    marginLeft: 8,
                    background: '#ff4d4f',
                    color: 'white',
                    borderRadius: 12,
                    padding: '0 8px',
                    fontSize: 12
                  }}>
                    {contadores.entradasPendientes}
                  </span>
                )}
              </span>
            } 
            key='entradas' 
          />
          <Tabs.Tab 
            title={
              <span>
                🚪 Salidas
                {contadores.salidasPendientes > 0 && (
                  <span style={{ 
                    marginLeft: 8,
                    background: '#ff4d4f',
                    color: 'white',
                    borderRadius: 12,
                    padding: '0 8px',
                    fontSize: 12
                  }}>
                    {contadores.salidasPendientes}
                  </span>
                )}
              </span>
            } 
            key='salidas' 
          />
        </Tabs>

        {/* Lista de habitaciones */}
        <div style={{ flex: 1, overflow: 'auto', padding: 12 }}>
          <PullToRefresh onRefresh={onRefresh}>
            {loading && !refreshing ? (
              <>
                <Skeleton.Title animated />
                <Skeleton.Paragraph animated />
              </>
            ) : filteredHabitaciones.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
                No hay {activeTab === 'entradas' ? 'entradas' : 'salidas'} para esta fecha
              </div>
            ) : (
              filteredHabitaciones.map((h, i) => renderHabitacionCard(h, i))
            )}
          </PullToRefresh>
        </div>

        {/* Botón flotante para asignación rápida - solo visible si hay sin asignar */}
        {habitaciones.some(h => h.numhab === 'sin-asignar') && (
          <FloatingBubble
            style={{
              '--initial-position-bottom': '24px',
              '--initial-position-right': '24px',
              '--z-index': '99',
            }}
          >
            <Button
              shape='circle'
              color='primary'
              size='large'
              onClick={() => {
                const sinAsignar = habitaciones.find(h => h.numhab === 'sin-asignar');
                if (sinAsignar && sinAsignar.clientes.length > 0) {
                  abrirAsignarHabitacion(sinAsignar.clientes[0], sinAsignar);
                } else {
                  Toast.show('No hay líneas sin habitación');
                }
              }}
            >
              <KeyOutlined style={{ fontSize: 24 }} />
            </Button>
          </FloatingBubble>
        )}

        {/* Modales */}
        <LectorDNIMobile
          visible={lectorVisible}
          onClose={() => setLectorVisible(false)}
          onSuccess={handleDNIProcesado}
          numReserva={reservaSeleccionada?.numReserva}
          linea={reservaSeleccionada?.linea}
          numOcupante={reservaSeleccionada?.numOcupante}
          nombreCliente={reservaSeleccionada?.nombre}
        />

        <AsignarHabitacionMovil
          visible={asignarVisible}
          onClose={() => setAsignarVisible(false)}
          onSuccess={cargarDatos}
          lineaSeleccionada={lineaSeleccionada}
        />

        <ModalOcupantesMovil
          visible={ocupantesModalVisible}
          onClose={() => setOcupantesModalVisible(false)}
          numReserva={ocupantesData.numReserva}
          linea={ocupantesData.linea}
          nombreCliente={ocupantesData.nombre}
          numHabitacion={ocupantesData.numHabitacion}
        />
      </div>
    </>
  );
};

export default CheckinCheckoutMovil;